<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import BillingList from "@/components/widgets/billing-list.vue";
import BillingModal from "@/components/modals/billing-modal.vue"
import Clients from "@/components/widgets/client-list.vue";
import Employees from "@/components/widgets/employee-list.vue";
import FeeModal from "@/components/modals/fee-template-modal.vue";
import DeliveryUnitServices from "@/components/tables/delivery-unit-services-table";
import { cloneDeep } from 'lodash';
import Swal from "sweetalert2";
import PrintOptions from "@/components/modals/print-options.vue";
export default {
  page: {
    title: "Billing",
  },
  components: {
    Layout,
    PageHeader,
    BillingList,
    BillingModal,
    Clients,
    Employees,
    FeeModal,
    DeliveryUnitServices,
    PrintOptions
  },
  data() {
    return {
        title: "Billing",
        items: [
            {
            text: "Dashboards",
            href: "/",
            },
            {
            text: "Billing",
            active: true,
            },
        ],
        pendingBillings: [],
        postedBillings: [],
        pendingLoads: false,
        postedLoads: false,
        modalTitle: '',
        clientOpt: '',
        fees: [],
        filteredFees: [],
    }
  },
  created(){
    this.changeCampus(this.$store.state.data.selectedCampus);
  },
  methods: {
    async changeCampus(campus) {
        this.pendingLoads = true;
        this.postedLoads = true;
        await this.fetchPendingBillings(campus.id);
        this.pendingLoads = false;
        await this.fetchPostedBillings(campus.id);
        this.postedLoads = false;
        this.getFees(campus.id);
    },
    async getFees(id){
        await this.$store
            .dispatch("fee/getFeesByCampus", id)
            .then((res) => {
                if (res.data.error) {
                    return this.showToast(res.data.errorMessage, "error");
                }
                res.data.map(item => {
                    item.selected = false;
                })
                this.fees = res.data;
            })
            .catch((error) => {
                this.showToast("Something went wrong! Cannot fetch delivery unit services.", "error");
            });
    },
    async fetchPendingBillings(id){
        await this.$store
            .dispatch("billing/getPendingBillings", id)
            .then((response) => {
                if (response.data.error) {
                    return this.showToast(response.data.errorMessage, "error");
                }
                response.data.map((item) => {   
                    item.visible = false;
                    item.selected = false;
                    item.showDetails = true;
                    item.itemVisible = false;
                    item.duService = {
                        id: item.deliveryUnitServiceId,
                        name: item.deliveryUnitService,
                        templates: []
                    }
                });
                this.pendingBillings = response.data.sort((a, b) => b.id - a.id);
            })
            .catch((err) => {
                this.showToast("Something went wrong - There was an error on fetching pending billings", 'error');
            });
    },
    async fetchPostedBillings(id){
        await this.$store
            .dispatch("billing/getPostedBillings", id)
            .then((response) => {
                if (response.data.error) {
                    return this.showToast(response.data.errorMessage, "error");
                }
                response.data.map((item) => {
                    item.visible = false;
                    item.showDetails = true;
                    item.itemVisible = false;
                });
                this.postedBillings = response.data.sort((a, b) => b.id - a.id);
            })
            .catch((err) => {
                this.showToast("Something went wrong - There was an error on fetching pending billings", 'error');
            });
    },
    createBilling(){
        this.$refs.billModal.resetBilling();
        this.$bvModal.show('create-billing');
    },
    searchClient(){
        this.modalTitle = 'Search Client';
        this.clientOpt = 'client';
        this.$bvModal.show('client-modal');
    },
    searchEmployee(){
        this.modalTitle = 'Search Employee';
        this.clientOpt = 'employee';
        this.$bvModal.show('client-modal');
    },
    addFees(duServices){
        this.modalTitle = 'Select Fees';
        this.filteredFees = [];
        this.fees.map(item => {
            item.selected = false;
        })
        this.filteredFees = this.fees.filter((item) => {
            return !duServices.some((template) => template.feeId == item.id);
        });
        this.$bvModal.show('fee-template-modal');
    },
    async onCreateBilling(modalData){
        let data = cloneDeep(modalData)
        data.billingDate = this.getDate(modalData.billingDate);
        data.dueDate = this.getDate(modalData.dueDate);
        data.penaltyPerDay = modalData.penaltyPerDay ? this.getExactAmt(modalData.penaltyPerDay) : 0;
        data.billingDetails.map(item => {
            item.amount = this.getExactAmt(item.amount);
            item.quantity = this.getExactAmt(item.quantity);
            item.total = this.getExactAmt(parseFloat(item.amount) * parseFloat(item.quantity));
        })
        if (data.id > 0) {
            await this.$store
                .dispatch("billing/updateBilling", { billingId: data.id, data })
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    let index = this.pendingBillings.findIndex(x => x.id == data.id);
                    this.pendingBillings.splice(index, 1, data);
                    this.$bvModal.hide('create-billing')
                    this.showToast("Billing successfully updated", "success");
                })
                .catch((err) => {
                    this.showToast("Something went wrong", "error");
                })
        }else{
            await this.$store
                .dispatch("billing/createNewBilling", data)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.visible = false;
                    res.data.showDetails = true;
                    res.data.itemVisible = false;
                    res.data.deliveryUnitService = cloneDeep(data.duService);
                    this.pendingBillings.unshift(res.data);
                    this.$bvModal.hide('create-billing')
                    this.showToast("Billing successfully added", "success");
                })
                .catch((err) => {
                    this.showToast("Something went wrong", "error");
                })
                
        }
    },
    getClient(modalData){
        let data = {
            clientId: modalData.id.toString(),
            clientName: modalData.name.trim(),
            clientTin: modalData.tin,
            clientAddress: modalData.addressPosition,
        }
        this.$refs.billModal.setBiller(data);
        this.$bvModal.hide('client-modal');
    },
    searchServices(){
        this.$bvModal.show('du-services-modal');
    },
    async getDeliveryUnitService(data) {
        this.$refs.billModal.setDUService(data);
        this.$bvModal.hide('du-services-modal');
    },
    updateBilling(data){
        this.$refs.billModal.updateBilling(data);
        this.$bvModal.show('create-billing');
    },
    removeBilling(id){
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#dc3545",
            cancelButtonColor: "#5c636a",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.value) {
                this.$store
                    .dispatch("billing/deleteBilling", id)
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, 'error')
                        }
                        let index = this.pendingBillings.findIndex(x => x.id == id);
                        this.pendingBillings.splice(index, 1);
                        this.showToast("Successfully deleted!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Error deleting billing!", "error");
                    });
                }
            });
    },
    postBilling(id){
        Swal.fire({
            title: "Are you sure?",
            text: "You want to post this?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            confirmButtonText: "Yes, post this!",
        }).then((result) => {
            if (result.value) {
                this.$store
                    .dispatch("billing/postBilling", id)
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, 'error')
                        }
                        let index = this.pendingBillings.findIndex(x => x.id == id);
                        let data = cloneDeep(this.pendingBillings[index]);
                        this.pendingBillings.splice(index, 1);
                        data.visible = false;
                        data.reference = res.data;
                        this.postedBillings.unshift(data);
                        this.showToast("Successfully posted!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Error posting billing!", "error");
                    });
                }
            });
    },
    postMultipleBilling(billings){
        let ids = billings.map(item => {
            return {id: item.id}
        });
        Swal.fire({
            title: "Are you sure?",
            text: "You want to post this?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            confirmButtonText: "Yes, post selected billings!",
        }).then((result) => {
            if (result.value) {
                this.$store
                    .dispatch("billing/postMultipleBilling", ids)
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, 'error')
                        }
                        ids.forEach(item => {
                            let index = this.pendingBillings.findIndex(x => x.id == item.id);
                            let data = cloneDeep(this.pendingBillings[index]);
                            this.pendingBillings.splice(index, 1);
                            data.visible = false;
                            this.postedBillings.unshift(data);
                        });
                        this.showToast("Successfully posted!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Error posting billing!", "error");
                    });
            }
        });
    },
    printInvoice(data){
        this.$refs.printOpt.putOptions({
            apiUrl: "/api/Report/Finance/Invoice",
            routeVariables: [data.reference],
        });
        this.$bvModal.show("print-options-modal");
    },
    addSelectedFees(selFees){
        this.$refs.billModal.addFeesToBilling(selFees);
        this.$bvModal.hide('fee-template-modal');
    },
    markAsPaid(billing) {
        Swal.fire({
            title: "Are you sure?",
            text: "You want to post this?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            confirmButtonText: "Yes, mark this as paid!",
        }).then((result) => {
            if (result.value) {
                this.$store
                    .dispatch("billing/markAsPaid", {
                        id: billing.id,
                        status: 'PAID',
                        isPaidOnline: false,
                    })
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, 'error')
                        }
                        billing.visible = false;
                        billing.status = 'PAID';
                        this.showToast("Successfully marked as paid!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Error marking as paid!", "error");
                    });
            }
        });
    }
    
  }
}
</script>
<template>
    <Layout @changeCampus="changeCampus">
        <PageHeader :title="title" :items="items" />
        <b-tabs
            pills
            vertical
            nav-class="p-0"
            nav-wrapper-class="col-sm-2"
            content-class="pt-0 px-2 text-muted"
        >
            <b-tab title-item-class="mb-2">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-"></i>
                    </span>
                    <span class="d-none d-sm-inline-block"
                        >Pending (<template v-if="!pendingLoads">{{
                            pendingBillings.length
                        }}</template
                        ><template v-if="pendingLoads"
                            ><b-spinner
                                type="grow"
                                class="wh-10p"
                                variant="success"
                                role="status"
                            ></b-spinner></template
                        >)</span
                    >
                </template>
                <BillingList 
                    type="pending"
                    :list="pendingBillings"
                    @createBilling="createBilling"
                    @updateBilling="updateBilling"
                    @removeBilling="removeBilling"
                    @postBilling="postBilling"
                    @printInvoice="printInvoice"
                    @postMultipleBilling="postMultipleBilling"
                />
            </b-tab>
            <b-tab title-item-class="mb-2">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-"></i>
                    </span>
                    <span class="d-none d-sm-inline-block"
                        >Posted (<template v-if="!postedLoads">{{
                            postedBillings.length
                        }}</template
                        ><template v-if="postedLoads"
                            ><b-spinner
                                type="grow"
                                class="wh-10p"
                                variant="success"
                                role="status"
                            ></b-spinner></template
                        >)</span
                    >
                </template>
                <BillingList 
                    type="posted"
                    :list="postedBillings"
                    @printInvoice="printInvoice"
                    @markAsPaid="markAsPaid"
                />
            </b-tab>
        </b-tabs>
        <BillingModal 
            ref="billModal"
            @submit="onCreateBilling"
            @search-client="searchClient"
            @search-employee="searchEmployee"
            @add-fee="addFees"
            @search-du-services="searchServices"
            @create-bill="onCreateBilling"
        />
        <b-modal
            id="client-modal"
            :title="modalTitle"
            size="lg"
            hide-footer
            no-close-on-backdrop
            no-close-on-escape
        >
            <Clients @fetchclient="getClient" v-if="clientOpt == 'client'" />
            <Employees @fetchemployee="getClient" v-if="clientOpt == 'employee'" />
        </b-modal>
        <b-modal
            id="du-services-modal"
            size="md"
            hide-footer
            no-close-on-backdrop
            no-close-on-escape
            title="Select Delivery Unit Service"
        >
            <DeliveryUnitServices @dropData="getDeliveryUnitService" />
        </b-modal>
        <print-options ref="printOpt"></print-options>
        <FeeModal 
            ref="feeModal"
            :fees="filteredFees"
            :modalTitle="modalTitle"
            @selected-fees="addSelectedFees"
        />
    </Layout>
</template>